module.exports = __webpack_public_path__ + "static/media/phone_dial_icon.22f44ae8.png";